import React, { useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Add, AddCircle, Trash, WeightMeter } from "iconsax-react";
import { PlusOne } from "@mui/icons-material";
import { isMobile } from "react-device-detect";
import Select from "react-select";

function ItemsAdd({
  items,
  setItems,
  setTotal,
  isEdit,
  setDeletedItems,
  setGstColletion,
  propdata,
}) {
  const [materialList, setMaterialList] = useState([]);
  const [packing, setPacking] = useState(0);
  const [transportation, setTransportation] = useState(0);
  const [other, setOther] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [igst, setIgst] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (propdata.rowData && Object.keys(propdata.rowData).length > 0) {
      setPacking(propdata?.rowData?.packing_charge);
      setTransportation(propdata?.rowData?.transport_charge);
      setOther(propdata?.rowData?.other_charge);
    }
  }, [propdata.rowData]);
  useEffect(() => {
    // Perform calculations whenever items, packing, transportation, or other charges change
    const tableTotal = items.reduce((sum, item) => sum + (item.amount || 0), 0);

    const totalCgst = items.reduce(
      (sum, item) => sum + (Number(item.cgstAmt) || 0),
      0,
    );
    const totalSgst = items.reduce(
      (sum, item) => sum + (Number(item.sgstAmt) || 0),
      0,
    );
    const totalIgst = items.reduce(
      (sum, item) => sum + (Number(item.igstAmt) || 0),
      0,
    );
    setCgst(totalCgst);
    setSgst(totalSgst);
    setIgst(totalIgst);

    setTotalAmount(
      tableTotal +
        totalCgst +
        totalSgst +
        totalIgst +
        Number(packing) +
        Number(transportation) +
        Number(other),
    );

    setTotal(tableTotal); // Update the total as well
    setGstColletion({
      packing: packing,
      transportation: transportation,
      other: other,
    });
  }, [items, packing, transportation, other]);

  useEffect(() => {
    getMaterialList();
  }, []);

  const getMaterialList = () => {
    utils
      .callAPI(
        "get",
        `/rawmaterial/list?page=${0}&per_page=${0}&created_by=&category=&item_name=&item_code=&brand_name=&unit=`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeMaterials = res?.result?.filter(
            (material) => material.status === "1",
          );
          setMaterialList(activeMaterials);
        } else {
          setMaterialList([]);
        }
      })
      .catch(() => {
        setMaterialList([]);
      });
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;

    if (field === "itemName") {
      const selectedItem = materialList.find((item) => item.id === value);
      updatedItems[index].hsnCode = selectedItem ? selectedItem.hsn_code : "";
      updatedItems[index].unit = selectedItem ? selectedItem.name : "";
    }

    if (
      field === "price" ||
      field === "qty" ||
      field === "disc" ||
      field === "noOfPackages"
    ) {
      const price = parseFloat(updatedItems[index].price) || 0;
      const qty = parseFloat(updatedItems[index].qty) || 0;
      const disc = parseFloat(updatedItems[index].disc) || 0;
      const rawAmount = price * qty * (1 - disc / 100);
      console.log("first", rawAmount);
      updatedItems[index].amount = Number(rawAmount.toFixed(4));
    }

    setItems(updatedItems);
  };

  useEffect(() => {
    const totalAmount = items.reduce(
      (sum, item) => sum + (item.amount || 0),
      0,
    );
    setTotal(totalAmount);
  }, [items, setTotal, setItems]);

  const handleAddRow = () => {
    setItems([
      ...items,
      {
        itemName: "",
        hsnCode: "",
        price: "",
        qty: "",
        unit: "",
        disc: "",
        amount: "",
      },
    ]);
  };

  const handleDeleteRow = (index, id) => {
    const updatedItems = [...items];
    const deletedItem = updatedItems[index];

    const newItems = updatedItems.filter((_, i) => i !== index);

    setItems(newItems);
    if (isEdit) {
      setDeletedItems((prevDeletedItems) => [...prevDeletedItems, deletedItem]);

      const updatedTotalAmount = newItems.reduce(
        (sum, item) => sum + (item.amount || 0),
        0,
      );
      setTotal(updatedTotalAmount);

      const updatedCgst = newItems.reduce(
        (sum, item) => sum + (item.cgstAmt || 0),
        0,
      );
      const updatedSgst = newItems.reduce(
        (sum, item) => sum + (item.sgstAmt || 0),
        0,
      );
      const updatedIgst = newItems.reduce(
        (sum, item) => sum + (item.igstAmt || 0),
        0,
      );

      setCgst(updatedCgst);
      setSgst(updatedSgst);
      setIgst(updatedIgst);

      setTotalAmount(
        updatedTotalAmount +
          updatedCgst +
          updatedSgst +
          updatedIgst +
          Number(packing) +
          Number(transportation) +
          Number(other),
      );
    }
  };

  const handleGSTChange = (index, gstType, value) => {
    const updatedItems = [...items];
    updatedItems[index][gstType] = value;

    const amount = updatedItems[index].amount || 0;
    const percentage = parseFloat(value) || 0;

    // Calculate GST Amount
    updatedItems[index][`${gstType}Amt`] = (amount * percentage) / 100;

    setItems(updatedItems);
  };

  const options = React.useMemo(
    () =>
      materialList.map((m) => ({
        value: m.id,
        label: m.product_name,
        hsn_code: m.hsn_code,
        unit: m.name,
      })),
    [materialList],
  );

  const handleSelectChange = (selectedOption, index) => {
    const updatedItems = [...items];

    updatedItems[index].itemName = selectedOption ? selectedOption.value : "";
    updatedItems[index].hsnCode = selectedOption ? selectedOption.hsn_code : "";
    updatedItems[index].unit = selectedOption ? selectedOption.unit : "";

    setItems(updatedItems);
  };
  return (
    <>
      <div className="table-responsive">
        <RB.Table striped bordered hover className="p-0">
          <thead>
            <tr>
              <th rowSpan="2">Select Items</th>
              <th rowSpan="2">HSN Code</th>
              <th rowSpan="2">No. of Packages</th>
              <th rowSpan="2">Price</th>
              <th rowSpan="2">Qty</th>
              {/* <th rowSpan="2">Unit</th> */}
              {/* <th rowSpan="2">Discount</th> */}
              <th rowSpan="2">Amount</th>
              <th colSpan="2">CGST</th>
              <th colSpan="2">SGST</th>
              <th colSpan="2">IGST</th>
            </tr>
            <tr>
              <th>%</th>
              <th>Amt</th>
              <th>%</th>
              <th>Amt</th>
              <th>%</th>
              <th>Amt</th>
            </tr>
          </thead>
          <tbody>
            {items
              .filter((item) => !item.isDelete)
              .map((item, index, visibleItems) => (
                <tr key={index}>
                  <td className="p-1" style={{ minWidth: "200px" }}>
                    <Select
                      classNamePrefix="react-select"
                      options={options}
                      // Find the object that matches the current ID to display it
                      value={
                        options.find((opt) => opt.value === item.itemName) ||
                        null
                      }
                      onChange={(selected) =>
                        handleSelectChange(selected, index)
                      }
                      isClearable
                      placeholder="Select Item..."
                      // Ensure the dropdown menu doesn't get cut off by the responsive table
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </td>
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.hsnCode}
                      readOnly
                      placeholder="HSN Code"
                      className="purchase-order-items-hsncode"
                      required
                    />
                  </td>
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.noOfPackages}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleItemChange(index, "noOfPackages", value);
                        }
                      }}
                      placeholder="No. of Packages"
                    />
                  </td>
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.price}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*(\.\d{0,4})?$/.test(value)) {
                          handleItemChange(index, "price", value);
                        }
                      }}
                      className="purchase-order-items-qty"
                      placeholder="Price"
                      required
                    />
                  </td>
                  <td className="p-1">
                    <div class="input-group purchase-order-items-qty1">
                      <RB.Form.Control
                        type="text"
                        value={item.qty}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*(\.\d{0,4})?$/.test(value)) {
                            handleItemChange(index, "qty", value);
                          }
                        }}
                        placeholder="Qty"
                        className=""
                        required
                      />
                      <span class="input-group-text p-1" id="basic-addon1">
                        {item.unit}
                      </span>
                    </div>
                  </td>

                  <td className="p-1 text-center">
                    {/* <RB.Form.Control
                      type="number"
                      value={Number(item.amount)}
                      readOnly
                      placeholder="Amount"
                      required
                      className="purchase-order-items-qty"
                    /> */}
                    {Number(item.amount).toFixed(4)}
                  </td>
                  {/* <td className="p-1">
                  <RB.InputGroup>
                    <RB.Form.Control
                      type="text"
                      value={item.disc}
                      className="purchase-order-items-disc"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d*$/.test(value) &&
                          (value === "" ||
                            (parseInt(value) >= 0 && parseInt(value) <= 100))
                        ) {
                          handleItemChange(index, "disc", value);
                        }
                      }}
                      placeholder="Disc"
                    />
                    <RB.InputGroup.Text>%</RB.InputGroup.Text>
                  </RB.InputGroup>
                </td> */}
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.cgst || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d*\.?\d*$/.test(value) &&
                          (value === "" ||
                            (parseInt(value) >= 0 && parseInt(value) <= 100))
                        ) {
                          handleGSTChange(index, "cgst", value);
                        }
                      }}
                      // onChange={(e) =>
                      //   handleGSTChange(index, "cgst", e.target.value)
                      // }
                      placeholder="%"
                      className="purchase-order-items-gst"
                    />
                  </td>
                  <td className="p-1 text-center">
                    {/* <RB.Form.Control
                      type="text"
                      value={item.cgstAmt || ""}
                      readOnly
                      placeholder="CGST Amt"
                      className="purchase-order-items-gst"
                    /> */}
                    {item.cgstAmt ? Number(item.cgstAmt).toFixed(2) : 0}
                  </td>
                  {/* SGST */}
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.sgst || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d*\.?\d*$/.test(value) &&
                          (value === "" ||
                            (parseInt(value) >= 0 && parseInt(value) <= 100))
                        ) {
                          handleGSTChange(index, "sgst", value);
                        }
                      }}
                      placeholder="%"
                      className="purchase-order-items-gst"
                    />
                  </td>
                  <td className="p-1 text-center">
                    {/* <RB.Form.Control
                      type="text"
                      value={item.sgstAmt || ""}
                      readOnly
                      placeholder="SGST Amt"
                      className="purchase-order-items-gst"
                    /> */}
                    {item.sgstAmt ? Number(item.sgstAmt).toFixed(2) : 0}
                  </td>
                  {/* IGST */}
                  <td className="p-1">
                    <RB.Form.Control
                      type="text"
                      value={item.igst || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d*\.?\d*$/.test(value) &&
                          (value === "" ||
                            (parseInt(value) >= 0 && parseInt(value) <= 100))
                        ) {
                          handleGSTChange(index, "igst", value);
                        }
                      }}
                      className="purchase-order-items-gst"
                      placeholder="%"
                    />
                  </td>
                  <td className="p-1 text-center">
                    {item.igstAmt ? Number(item.igstAmt).toFixed(2) : 0}
                    {/* <RB.Form.Control
                      type="text"
                      value={item.igstAmt || ""}
                      readOnly
                      placeholder="IGST Amt"
                      className="purchase-order-items-gst"
                    /> */}
                  </td>
                  <td className="p-1">
                    {items.length > 1 && (
                      <RB.Button
                        className="btn-flat"
                        title="Delete"
                        onClick={() => handleDeleteRow(index, item.id)}
                      >
                        <Trash />
                      </RB.Button>
                    )}

                    {/* {index === visibleItems.length - 1 && (
                      <RB.Button
                        className="btn-flat"
                        title="Add"
                        onClick={handleAddRow}
                        // disabled={visibleItems.length === 1}
                      >
                        <AddCircle />
                      </RB.Button>
                    )} */}
                  </td>
                </tr>
              ))}
          </tbody>
          <RB.Button
            className="btn bt-primary mt-2"
            title="Add"
            size="sm"
            onClick={handleAddRow}
            // disabled={visibleItems.length === 1}
          >
            Add New
          </RB.Button>
          {/* <tfoot>
          <tr>
            <td colSpan="5" className="text-end">
              <strong>Total:</strong>
            </td>
            <td>
              <RB.Form.Control
                type="number"
                value={items
                  .reduce((sum, item) => sum + (item.amount || 0), 0)
                  .toFixed(2)}
                readOnly
              />
            </td>
            <td colSpan="2">
              <RB.Form.Control
                type="number"
                value={items
                  .reduce((sum, item) => sum + (item.cgstAmt || 0), 0)
                  .toFixed(2)}
                readOnly
              />
            </td>
            <td colSpan="2">
              <RB.Form.Control
                type="number"
                value={items
                  .reduce((sum, item) => sum + (item.sgstAmt || 0), 0)
                  .toFixed(2)}
                readOnly
              />
            </td>
            <td colSpan="2">
              <RB.Form.Control
                type="number"
                value={items
                  .reduce((sum, item) => sum + (item.igstAmt || 0), 0)
                  .toFixed(2)}
                readOnly
              />
            </td>
          </tr>
        </tfoot> */}
        </RB.Table>
      </div>
      <RB.Row className="justify-content-end mt-3">
        <div className="col-lg-6">
          {/* Amount */}
          <div className="d-flex justify-content-between mb-1">
            <span>Amount</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={Number(
                items.reduce((sum, item) => sum + item.amount, 0),
              ).toFixed(4)}
              readOnly
            />
          </div>
          {/* Packing & Forwarding */}
          <div className="d-flex justify-content-between mb-1">
            <span>Packing & Forwarding</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={packing}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setPacking(value);
                }
              }}
            />
          </div>
          {/* Transportation */}
          <div className="d-flex justify-content-between mb-1">
            <span>Transportation</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={transportation}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setTransportation(value);
                }
              }}
            />
          </div>
          {/* Other */}
          <div className="d-flex justify-content-between mb-1">
            <span>Other</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={other}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setOther(value);
                }
              }}
            />
          </div>
          {/* CGST */}
          <div className="d-flex justify-content-between mb-1">
            <span>CGST</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={cgst ? Number(cgst)?.toFixed(4) : 0}
              readOnly
            />
          </div>
          {/* SGST */}
          <div className="d-flex justify-content-between mb-1">
            <span>SGST</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={sgst ? Number(sgst)?.toFixed(4) : 0}
              readOnly
            />
          </div>
          {/* IGST */}
          <div className="d-flex justify-content-between mb-1">
            <span>IGST</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={igst ? Number(igst)?.toFixed(2) : 0}
              readOnly
            />
          </div>
          {/* Total Amount */}
          <div className="d-flex justify-content-between fw-bold">
            <span>Total Amount</span>
            <input
              type="text"
              className={`form-control w-auto  ${isMobile ? "form-control-sm" : ""}`}
              value={totalAmount ? Number(totalAmount).toFixed(4) : 0}
              readOnly
            />
          </div>
        </div>
      </RB.Row>
    </>
  );
}

export default ItemsAdd;
